import Ajax from '../../../../util/ajax';
export function zigbeeOnWithTimedOff(nid, eid, onWithTimedOff) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/6/command/on-with-timed-off';
        const value = {
            'accept only when on': onWithTimedOff.acceptOnlyWhenOn,
            'on time': onWithTimedOff.onTime,
            'off wait time': onWithTimedOff.offWaitTime
        };
        ajax.post(url, value);
    };
}
